





























































































import { Vue, Component } from "vue-property-decorator";
import * as user from "../../_store/user.module";
import * as activity from "../../_store/activity.module";
import * as auth from "../../_store/auth.module";
import { userUtils } from "../../_utils/userUtils";
import { bus } from "../../main";
import { Activities } from "../../_models/activities";
import CardTitle from "../../components/CardTitle.vue";
import { EnterpriseSubscription } from "../../_models/enterpriseSubscription";
import { router } from "../../_router";
import * as data from "../../_store/data.module";
import * as temp from "../../_store/temp.module";

@Component({
  components: {
    CardTitle
  }
})
export default class IscrizioniTirFormativi extends Vue {
  private statusTirFormativi: any[];
  private titleParams: object;
  private isComplete: boolean;

  private attivita: any;
  private istituti: any;

  constructor() {
    super();
    this.titleParams = {
      title: "Tirocini Formativi Istituti",
      cols: "12",
      sm: "6",
      md: "5",
      lg: "5"
    };
    this.statusTirFormativi = [];
    this.isComplete = false;

    this.attivita = [];
    this.istituti = [];
  }

  subscribeToActivities(idIstituto: any, idAttivita: any) {
    var idAnnoScolastico = temp.readIdAnnoScolastico(this["$store"]);
    var enterpriseInfo = user.readEnterpriseInfo(this["$store"]);
    var payload = {
      idAttivita: idAttivita,
      idAzienda: enterpriseInfo.idAzienda
    };
    var payload2 = {
      idAzienda: enterpriseInfo.idAzienda,
      idIstituto: idIstituto
    };
    this.isComplete = userUtils.checkEnterpriseInfo(enterpriseInfo);
    if (this.isComplete !== false) {
      data
        .dispatchRespDoc(this["$store"], payload2)
        .then(response => {
          if (
            response.IdDocNominaResponsabile !== undefined &&
            response.IdDocNominaResponsabile !== null
          ) {
            if (response.StatoDocumento === 2) {
              activity
                .dispatchSubscribeToActivityAzienda(this["$store"], payload)
                .then(result => {
                  router.push({
                    name: "tirFormativiAzienda",
                    params: {
                      idIstituto: String(idIstituto),
                      idAnnoScolastico: String(idAnnoScolastico),
                      idIscrizioneAttivita: String(result)
                    }
                  });
                })
                .catch(error => {
                  if (error.response.status === 401) {
                    bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
                    this["$router"].push("/login");
                  } else {
                    bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
                  }
                })
                .catch(error => {
                  if (error.response.status === 403) {
                    bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
                    this["$router"].push("/login");
                  } else {
                    bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
                  }
                });
            } else {
              bus.$emit(
                "noDoc",
                "E' necessario attendere la verifica del documento per la nomina del responsabile trattamento dati"
              );
            }
          } else {
            bus.$emit(
              "noDoc",
              "E' necessario compilare il documento per la nomina del responsabile trattamento dati. Questo si può trovare nella sezione 'Amministrazione'/'Moduli'"
            );
          }
        })
        .catch(error => {
          if (error.response.status === 403) {
            bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
            this["$router"].push("/login");
          } else {
            bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
          }
        });
    } else {
      bus.$emit("incompleteInfo");
    }
  }

  continueToTirFormativi(
    idIstituto: any,
    // idAnnoScolastico: any,
    idAttivita: number,
    idIscrizione: number
  ) {
    var idAnnoScolastico = temp.readIdAnnoScolastico(this["$store"]);
    var enterpriseInfo = user.readEnterpriseInfo(this["$store"]);
    var doc: any;
    var payload = {
      idAzienda: enterpriseInfo.idAzienda,
      idIstituto: idIstituto
    };
    this.isComplete = userUtils.checkEnterpriseInfo(enterpriseInfo);
    if (this.isComplete !== false) {
      // userUtils.checkRespModule(enterpriseInfo.id, idIstituto)
      // doc = userUtils.checkRespModule(enterpriseInfo.id, idIstituto)
      data
        .dispatchRespDoc(this["$store"], payload)
        .then(response => {
          if (
            response.IdDocNominaResponsabile !== undefined &&
            response.IdDocNominaResponsabile !== null
          ) {
            if (response.StatoDocumento === 2) {
              router.push({
                name: "tirFormativiAzienda",
                params: {
                  idIstituto: String(idIstituto),
                  idAnnoScolastico: String(idAnnoScolastico),
                  idIscrizioneAttivita: String(idIscrizione)
                }
              });
            } else {
              bus.$emit(
                "noDoc",
                "E' necessario attendere la verifica del documento per la nomina del responsabile trattamento dati"
              );
            }
          } else {
            bus.$emit(
              "noDoc",
              "E' necessario compilare il documento per la nomina del responsabile trattamento dati. Questo si può trovare nella sezione 'Amministrazione'/'Moduli'"
            );
          }
        })
        .catch(error => {
          if (error.response.status === 403) {
            bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
            this["$router"].push("/login");
          } else {
            bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
          }
        });
    } else {
      bus.$emit("incompleteInfo");
    }
  }

  created() {
    var idAnnoScolastico = temp.readIdAnnoScolastico(this["$store"]);
    var token = localStorage.getItem("userToken");
    var parsedToken: any;
    if (token !== null) {
      parsedToken = userUtils.parseToken(token);
    }
    var payload = {
      idUtente: parsedToken.IdUtente,
      tipoSoggetto: parsedToken.IdTipoSoggetto,
      username: parsedToken.Username
    };
    user
      .dispatchSetUserInfo(this["$store"], payload)
      .then(() => {
        user
          .dispatchSetEnterpriseInfo(this["$store"])
          .then(() => {
            bus.$emit("loadMenu");
            var enterpriseInfo = user.readEnterpriseInfo(this["$store"]);
            var payload = {
              idAzienda: enterpriseInfo.idAzienda,
              idAnnoScolastico: idAnnoScolastico,
              activityType: "tirocinioFormativo"
            };
            var listaAttivitaIstituto: any[] = [];
            activity
              .dispatchGetAttivitaIstitutiInteresseAzienda(
                this["$store"],
                payload
              )
              .then(result => {
                result.forEach((element: any) => {
                  if (!this.istituti.includes(element.idIstituto)) {
                    this.istituti.push(element.idIstituto);
                  }
                });
                this.istituti.forEach((istituto: any) => {
                  var istitutoElem = {
                    idIstituto: 0,
                    denominazioneIstituto: "",
                    attivitaIstituto: []
                  };
                  istitutoElem.idIstituto = istituto;
                  result.forEach((attivita: any) => {
                    if (attivita.idIstituto === istitutoElem.idIstituto) {
                      istitutoElem.denominazioneIstituto =
                        attivita.denominazioneIstituto;
                      istitutoElem.attivitaIstituto.push({
                        //@ts-ignore
                        idIscrizione: attivita.idIscrizione,
                        //@ts-ignore
                        idAttivitaIstituto: attivita.idAttivitaIstituto,
                        //@ts-ignore
                        idAnnoScolastico: attivita.idAnnoScolastico,
                        //@ts-ignore
                        idAzienda: attivita.idAzienda,
                        //@ts-ignore
                        dataIscrizione: attivita.dataIscrizione,
                        //@ts-ignore
                        idTipoAttivita: attivita.idTipoAttivita,
                        //@ts-ignore
                        nomeAttivita: attivita.nomeAttivita,
                        //@ts-ignore
                        statoPeriodoIscrizione: attivita.statoPeriodoIscrizione
                      });
                    }
                  });
                  listaAttivitaIstituto.push(istitutoElem);
                });
                this.attivita = listaAttivitaIstituto;
              });
          })
          .catch(() => {
            bus.$emit("stopLoading");
            auth.dispatchLogout(this["$store"]);
            user.dispatchClearState(this["$store"]);
            this["$router"].push("/sessionExpired");
          });
      })
      .catch(() => {
        bus.$emit("stopLoading");
        auth.dispatchLogout(this["$store"]);
        user.dispatchClearState(this["$store"]);
        this["$router"].push("/sessionExpired");
      });
  }
}
